import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { ExternalLinkIcon } from '@/components/icons/external-link';
import { Banner } from '@/components/ui/banner';
import { Button } from '@/components/ui/button';
import { useOpeningDetails } from '@/contexts/opening-context';

/**
 * Banner shown when the current opening is inactive or/and sourcing is disabled.
 * with a link to edit opening page
 * If the opening is inactive or sourcing is disabled, the respective banner is shown
 * If the opening is both inactive and sourcing is disabled, inactive banner would be shown
 */
export function PostingUnavailableBanner() {
  const intl = useIntl();
  const { opening } = useOpeningDetails();
  const {
    isActive: isOpeningActive,
    isSourcingEnabled,
    url: openingUrl,
  } = opening;

  if (isOpeningActive && isSourcingEnabled) {
    return null;
  }

  return (
    <Banner
      color="rose"
      title={
        !isOpeningActive
          ? intl.formatMessage({
              defaultMessage: 'Opening Inactive — Job Posting Disabled',
              description:
                'Warning title: this requisition is off and cannot post to boards',
            })
          : intl.formatMessage({
              defaultMessage: 'Sourcing Disabled',
              description:
                'Warning title: org turned off paid sourcing for this role only',
            })
      }
      description={
        !isOpeningActive
          ? intl.formatMessage({
              defaultMessage:
                'This opening is inactive. Posting to job boards and sourcing campaigns are paused. Activate the opening to resume hiring.',
              description:
                'Explains that inactive jobs stop all distribution until reactivated',
            })
          : intl.formatMessage({
              defaultMessage:
                'Sourcing is turned off for this opening. Job posting and campaigns are paused until sourcing is enabled.',
              description:
                'Explains that the account disabled sourcing spend while the job stays open',
            })
      }
      button={
        openingUrl && (
          <Button variant="secondary" asChild>
            <Link to={openingUrl} target="_blank">
              <ExternalLinkIcon className="text-fx-neutral-900" />
              {!isOpeningActive ? (
                <FormattedMessage
                  defaultMessage="Activate opening"
                  description="CTA to turn the requisition back on from the employer job form"
                />
              ) : (
                <FormattedMessage
                  defaultMessage="Enable Sourcing"
                  description="CTA to re-enable paid sourcing channels for this opening"
                />
              )}
            </Link>
          </Button>
        )
      }
    />
  );
}
